const ACTIONS = {
  GET_AD: "GetAd",
};

export { ACTIONS };
